

















































import SupportService from '../../api/support/SupportService';
import LayoutService from '../../service/LayoutService';
import localstorage from '../../store/localstorage';
import { Component, Vue, Watch } from 'vue-property-decorator';
import Socket from '../../api/websocket/socket';
import LogService from '../../api/broadcast/LogService';
import moment from 'moment';
@Component({
  components: {
  }
})
export default class SupportConversation extends Vue {
  private msgfromaeroguestsupport: any = '';
  public msg: any = '';
  private userTicket: any;
  public comments: any = '';
  private fullname: any;
  private socket: any;
  private socketResponse: any;
  public showErrorMsg: any = false;
  private logIdentifier: string;

  async created () {
    Socket.$on('message', this.msgHandler);
    await this.getTicketData();
    await this.getConversation();
    await this.setHotelColor();
    await this.getDataFromLocalstorage();
    this.logIdentifier = `${this.$route.params.identifier}:${this.$route.params.token}`;
  }

  beforeDestroy () {
    Socket.$off('message', this.msgHandler);
  }

  mounted () {
    this.fileMangementFromGallery();
  }

  private async msgHandler (msg: any) {
    if (this.comments.TicketID === msg.Id) {
      this.pushDataToAHTMLElement(msg.Message.CommentImage, msg.Message.CommentText, msg.Message.Fullname, msg.Message.Identifier, true);
    }
  }

  @Watch('msgfromaeroguestsupport') private async newMsgFromAeroguestSupport () {
    if (this.comments.TicketID === this.msgfromaeroguestsupport.Id) {
      this.pushDataToAHTMLElement(this.msgfromaeroguestsupport.Message.CommentImage, this.msgfromaeroguestsupport.Message.CommentText, this.msgfromaeroguestsupport.Message.Fullname, this.msgfromaeroguestsupport.Message.Identifier, true);
    }
  }

  private getDataFromLocalstorage () {
    try {
      const userInfo = localstorage.GetBillingAddressData();
      if (userInfo.FirstName === undefined || userInfo.FirstName === null || userInfo.FirstName === '') {
        this.fullname = 'User';
      } else {
        this.fullname = userInfo.FirstName + ' ' + userInfo.LastName;
      }
    } catch (error) {
      // do nothing
    }
  }

  private fileMangementFromGallery () {
    const fileInput = document.getElementById('file-input-from-galary');
    fileInput!.onchange = async (event: any) => {
      const idFile = event.target.files[0];
      if (idFile !== undefined) {
        this.$store.state.idFileConversation = idFile;
        this.loadImage();
      }
    };
  }

  private async loadImage () {
    const idFile = this.$store.state.idFileConversation;
    const reader = new FileReader();
    reader.onloadend = () => this.processImage(reader.result);
    await reader.readAsDataURL(idFile);
  }

  public async processImage (result: any) {
    // New stuff:
    await this.resizeDataURL(result, (result: any) => {
      const idAsBase64 = result.split(',');
      this.addComment('', idAsBase64[1]);
    });
  }

  public resizeDataURL (data: string, callback: any) {
    const img = document.createElement('img');
    img.onload = async function () {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      // Minimizing image size to avoid 413 request to large.
      let ratio: any;
      if (img.height > 1000 || img.width > 1000) {
        // Maximum wanted size in pixels.
        ratio = [1000 / img.width, 1000 / img.height];
        ratio = Math.min(ratio[0], ratio[1]);
      } else {
        ratio = 1;
      }
      canvas.width = img.width * ratio;
      canvas.height = img.height * ratio;
      ctx!.drawImage(img, 0, 0, (img.width * ratio), (img.height * ratio));
      let result = canvas.toDataURL('image/jpeg', 1);
      let kiloBytes = Math.trunc((3 * (result.length / 4) / 1000));
      let quality = 1;
      // The server's max size of the image is unkown, but 243kb image works
      while (kiloBytes > 1000) {
        quality -= 0.1;
        result = await canvas.toDataURL('image/jpeg', quality);
        kiloBytes = Math.trunc((3 * (result.length / 4) / 1000));
        if (quality === 0.1) {
          break;
        }
      }
      callback(result);
    };
    img.src = data;
  }

  private async getConversation () {
    try {
      this.comments = await SupportService.GetUserBTCComment(this.userTicket.TicketID);
      for (const comment of this.comments.CommentList) {
        comment.Timestamp = moment(comment.Timestamp).fromNow();
      }
      const container: any = await document.querySelector('.conversation-position');
      container.scrollTop = container.scrollHeight;
      try {
        container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        LogService.LogInformation(`ScrollIntoView failed at conversation-position (SupportConversation.vue), error: ${error}`, {}, this.logIdentifier);
      }
      await this.$forceUpdate();
    } catch (error) {
      LogService.LogInformation(`Support-Conversation.vue failed to get GetUserBTCComment, bookingid: ${localstorage.GetwebCheckInfo()?.BookingId}, Error: ${JSON.stringify(error)}`, { }, `${this.logIdentifier}:${localstorage.GetwebCheckInfo()?.BookingId}`);
    }
  }

  private async pushDataToAHTMLElement (image: string, msg: string, fullname: string, identifier: string, SentFromAeroguest: boolean) {
    const container: any = document.querySelector('.conversation-position');
    this.comments.CommentList.push({ CommentImage: image, CommentText: msg, Fullname: fullname, Identifier: identifier, SentFromAeroguest: SentFromAeroguest });
    await this.$forceUpdate();
    container.scrollTop = container.scrollHeight;
    try {
      container.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (error) {
      LogService.LogInformation(`ScrollIntoView failed at conversation-position (SupportConversation.vue), error: ${error}`, {}, this.logIdentifier);
    }
  }

  public async addComment (msg: any, image?: any) {
    try {
      if (msg !== '' || image !== undefined) {
        image = image === undefined ? null : image;
        msg = msg === '' ? null : msg;
        await SupportService.AddBTCComment(this.userTicket.TicketID, msg, this.$route.params.identifier, image, this.fullname, false);
        this.pushDataToAHTMLElement(image, msg, this.fullname, this.$route.params.identifier, false);
        this.msg = '';
      }
    } catch (error) {
      LogService.LogInformation(`SupportConversation.vue failed to send msg, bookingid: ${localstorage.GetwebCheckInfo()?.BookingId}, Error: ${JSON.stringify(error)}`, { }, `${this.logIdentifier}:${localstorage.GetwebCheckInfo()?.BookingId}`);
      this.showErrorMsg = true;
      setTimeout(() => { this.showErrorMsg = false; }, 4000);
    }
  }

  private async setHotelColor () {
    try {
      let webCheckInData: any = await localstorage.GetwebCheckInData();
      if (webCheckInData !== null) {
        webCheckInData = await JSON.parse(webCheckInData);
        LayoutService.SetHotelColor(webCheckInData.HotelColor);
      } else {
        document.body.style.setProperty('--hotel-color', '#61566E');
      }
    } catch (error) {
      LogService.LogInformation(`SupportConversation.vue failed to get hotel color, bookingid: ${localstorage.GetwebCheckInfo()?.BookingId}, Error: ${JSON.stringify(error)}`, { }, `${this.logIdentifier}:${localstorage.GetwebCheckInfo()?.BookingId}`);
    }
  }

  private getTicketData () {
    if (this.$route.params.userTicket !== undefined) {
      this.userTicket = this.$route.params.userTicket;
    } else {
      this.userTicket = localstorage.getUserTicket()[this.$route.params.chatRoom];
    }
  }
}
